import { useRef } from 'react';
import { v4 } from 'uuid';

const useUUID = () => {
    const uuidRef = useRef<string>(v4());
    return uuidRef.current;
};

export default useUUID;
